export default [  
  {
    path: '/branches',
    name: 'branches',
    component: () => import('@/views/modules/branches/list'),
    meta: {
      requiresAuth: true,
      layout: 'app',
      title:'Branches List',
      breadcrumb: [
        { text: 'Home',  to: { name: "home" } },
        { text: 'Branches' }
      ]
    },
    children:[
      {
        path: '/branches/create',
        name: 'branches-create',
        component: () => import('@/views/modules/branches/create'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Branch Create',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Branches', link: '/branches' },
            { text: 'Create' }
          ]
        }
      },
      {
        path: '/branches/:id/edit',
        props: true,
        name: 'branches-edit',
        component: () => import('@/views/modules/branches/edit'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Branches Edit',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Branch',  to: { name: "branches-show" }, param: 'id' },
            { text: 'Edit' }
          ]
        }
      },
      {
        path: '/branches/:id/show',
        props: true,
        name: 'branches-show',
        component: () => import('@/views/modules/branches/show'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Branches Details',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Branches',  to: { name: "branches" } },
            { text: 'Details' }
          ]
        }
      },
    
    ]
  },
 
]